<template>
  <v-card outlined>
    <v-card-title class="caption primary--text text-uppercase font-weight-bold">
      Route Details
    </v-card-title>

    <v-divider />

    <v-card-text>
      <v-row no-gutters>
        <v-col cols="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-subtitle>Route ID</v-list-item-subtitle>
              <v-list-item-title>{{ routeDetails.routeId }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>

        <v-col cols="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-subtitle>Total Pallets </v-list-item-subtitle>
              <v-list-item-title>{{ routeDetails.total_delivered_pallets }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>

        <v-col cols="6">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-subtitle>Date</v-list-item-subtitle>
              <v-list-item-title>
                {{ humanizeDateFromSeconds(routeDetails.date, 'YYYY-MM-DD') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { humanizeDateFromSeconds } from '@/utils/misc';

export default {
  props: {
    routeDetails: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    humanizeDateFromSeconds,
  },
};
</script>
